<template>
    <div>
        <div class="inAnimation_Wrapper">
            <div class="d-flex align-items-center justify-content-between">
                <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    {{ title }}
                </label>
                <Switches theme="bootstrap" v-model="isSwitchOn" color="success" size="small"
                    style="width: 25px; height: 25px;"></Switches>
            </div>
            <select :value="selected" @change="selectAnimate" :disabled="!isActive" class="form-control">
                <option value="">None</option>
                <option v-for="(anim, index) in animationList" :value="anim" :key="index">
                    {{ anim }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
import Switches from "vue-switches";

export default {
    name: "AnimationDropdown",
    props: {
        title: String,
        animationList: Array,
        animateType: String,
        isdisabled: { type: Function },
        isActive: Boolean,
    },
    components: {
        Switches,
    },
    data() {
        return {
            selected: "",
            isSwitchOn: this.isActive,
        };
    },
    computed: {
        getActiveObj() {
            return this.$store.getters.getActiveObjectprops;
        },
    },
    watch: {
        getActiveObj(value) {
            if (this.animateType === "IN") {
                this.selected = this.animationList.includes(
                    value.animationClassIn.split("animate__").at(-1)
                )
                    ? value.animationClassIn.split("animate__").at(-1)
                    : "";
            } else if (this.animateType === "OUT") {
                this.selected = this.animationList.includes(
                    value.animationClassOut.split("animate__").at(-1)
                )
                    ? value.animationClassOut.split("animate__").at(-1)
                    : "";
            } else {
                this.selected = this.animationList.includes(
                    value.animationClassLoop.split("animate__").at(-1)
                )
                    ? value.animationClassLoop.split("animate__").at(-1)
                    : "";
            }
        },
        isSwitchOn(value) {
            this.isdisabled(value);
            if (!value) {
                this.removeAnimation();
            }
        },
        isActive(value) {
            console.log("workingisactive ");
            console.log(value);
            this.isSwitchOn = value;
            if (!value) {
                this.removeAnimation();
            }
        },
    },
    methods: {
        selectAnimate(e) {
            this.selected = e.target.value;
            let animationType;

            if (this.animateType === "IN") {
                animationType = "IN";
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClassIn: e.target.value ? `animate__animated animate__delay-1s animate__${e.target.value}` : "",
                });
            } else if (this.animateType === "OUT") {
                animationType = "OUT";
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClassOut: e.target.value ? `animate__animated animate__delay-1s animate__${e.target.value}` : "",
                });
            } else {
                animationType = "LOOP";
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClassLoop: e.target.value ? `animate__animated animate__delay-1s animate__${e.target.value}` : "",
                });
            }

            const currentObj = this.$store.getters.getActiveObjectprops;
            let updatedSequence = [...(currentObj.AnimationSequence || [])];
            console.log("updatedSequence", updatedSequence);

            if (!e.target.value) {
                updatedSequence = updatedSequence.filter((anim) => anim !== animationType);
            } else {
                if (!updatedSequence.includes(animationType)) {
                    updatedSequence.push(animationType);
                }
            }

            this.$store.dispatch("setCurrentObjectProperties", {
                AnimationSequence: updatedSequence,
            });

            console.log("Updated AnimationSequence:", updatedSequence);
        },

        removeAnimation() {
            let animationType;

            if (this.animateType === "IN") {
                animationType = "IN";
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClassIn: "",
                });
            } else if (this.animateType === "OUT") {
                animationType = "OUT";
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClassOut: "",
                });
            } else {
                animationType = "LOOP";
                this.$store.dispatch("setCurrentObjectProperties", {
                    animationClassLoop: "",
                });
            }

            const currentObj = this.$store.getters.getActiveObjectprops;
            let updatedSequence = [...(currentObj.AnimationSequence || [])];

            updatedSequence = updatedSequence.filter((anim) => anim !== animationType);

            this.$store.dispatch("setCurrentObjectProperties", {
                AnimationSequence: updatedSequence,
            });

            console.log("Animation removed. Updated AnimationSequence:", updatedSequence);
        },
    },
};
</script>
